// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalError_header__3zOJ1","footer":"ModalError_footer__1m0Io"};